import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, Field, reduxForm, reset } from 'redux-form';
import { renderAutoCompleteMultipleSelection, renderCheckBox, renderDateField, renderTextField, renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import RaisedButton from 'material-ui/RaisedButton';
import PaginatorCustom from '../../../../components/paginationCustom';
import { getClaimMasterData, getPatient, getProcessedClaims, SubmitBatchEDIClaimForSecondary, updateClaimServiceLineDetails, updateClaimServiceLineModifier, EDI835Download, ParseEDI835FromClearingHouseFromPage, ParseEDI835FromClearingHouseFromMasterAccount,downloadBatchEDI837 } from './actions/ManageClaimActions';
import { ART, BALLSBRIDGEBCS, EBS, resetFiltersAndSorting, showFormatedDate, showNormalizedRate, STEPUPOUTPATIENT } from '../../../../actions/utilAction';
import SortingCustom from '../../../../components/SortingCustom';
import SubmitClaimForSecondaryPayerModal from './SubmitClaimForSecondaryPayer_Modal';
import moment from 'moment';
import ClaimInternalNotesModal from './ClaimInternalNotes_Modal';
import BatchGenerateForm1500SecondaryFromProcessedClaimsModal from './BatchGenerateForm1500SecondaryFromProcessedClaims_Modal';
import AddNoteModal from './AddNoteModal';
import CliamHistoryModal from './CliamHistoryModal';
import BatchSubmitClaimToSecondaryModal from './BatchSubmitClaimToSecondary_Modal';
import BatchRenderingProviderModal from './BatchRenderingProvider_Modal';
import BatchResubmitClaimModal from './BatchResubmitClaim_Modal';
import BatchUpdateRateModal from './BatchUpdateRate_Modal';
import Upload_ERA_Modal from './Upload_ERA_Modal';
import { getIscalledFromERAMouleFlag } from './actions/ManageClaimActions';
import Alert from 'react-s-alert';
// import { SubmitButtonModal } from '../../../../components/buttons';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};
class ProcessedClaim extends Component {

  constructor(props) {
    super(props);

    this.state = {
      claimId: null,
      patientName: null,
      payerName: null,
      claimIdArray: [],
      PatientId: null,
      PatientIds: null,
      ServiceCodes: null,
      RenderingProviderIds: null,
      openSubmitClaimModal: false,
      openBatchGenerateForm1500Modal: false,
      openBatchSubmitClaimToSecondaryModal: false,
      openDownloadBatchClaimToSecondaryModal: false,
      openBatchRenderingProviderModal: false,
      openBatchResubmitClaimModal: false,
      openBatchUpdateRateModal: false,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      FromPaidDate: null,
      ToPaidDate: null,
      selectedEDIClaimIds: [],
      selectedEDIAndNonEDIClaimIds: [],
      AdjustmentsGroupCodes: null,
      MasterClaimStatusCodes: null,
      openInternalNotesModal: false,
      isAddNoteModalOpen: false,
      openClaimHistoryModal: false,
      masterTags: [],
      isExcludeTag: [],
      IsSearchForSingleClaim: false,
      selectedEDIClaimsPayerControlNumber: [],
      selectedEDIClaimsSecondaryPayerControlNumber: [],
      locationId: 0,
      ClickedOn : '',
      ServiceLocationTypeIds: null,
      ClaimPaymentStatusIds: null,
      AuthorizationNumberIds: null,
      open:false,
      isUpload_ERA :false,
      isChangedAfterBilling : false,
    };

    this.filter = {
      sort_Column: 'claimId',
      sort_Order: 'desc',
    };

    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchProcessedClaim = this.handleSearchProcessedClaim.bind(this);
    this.handleClaimIDCheck = this.handleClaimIDCheck.bind(this);
    this.checkAllClaimId = this.checkAllClaimId.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.CheckClaim = this.CheckClaim.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);
    this.handleEditAlternateServiceCode = this.handleEditAlternateServiceCode.bind(this);
    this.handleEditAlternateModifier = this.handleEditAlternateModifier.bind(this);
    this.handleSyncERA = this.handleSyncERA.bind(this);
    this.handleSyncERAFromMasterAccount = this.handleSyncERAFromMasterAccount.bind(this);
    // this.uploadDocumenthandler = this.uploadDocumenthandler.bind(this);
    this.closeUploadDocument = this.closeUploadDocument.bind(this);
  }
  
  uploadDocumenthandler = () => {
    // Alert.closeAll();
    this.setState({ isUpload_ERA :true });
  }
  closeUploadDocument = () => {
    this.setState({isUpload_ERA : false})
  }

  loadData(page_number) {
    let IsNoPaymentStatus = false;
    if (this.state.ClaimPaymentStatusIds && this.state.ClaimPaymentStatusIds.length === 1) {
      IsNoPaymentStatus = this.props.masterClaimPaymentStatus.filter((obj) => obj.id === this.state.ClaimPaymentStatusIds[0] && obj.globalCodeValue.toLowerCase() === 'no payment status').length > 0 ? true : false;
    }
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'claimId',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      contain_filters: {
        claimId: this.state.ClaimId && this.state.IsSearchForSingleClaim ? (Number.isInteger(this.state.ClaimId) ? 'CL' + this.state.ClaimId.toString().trim() : this.state.ClaimId.trim()) : null,
        patientIds: this.state.PatientIds ? this.state.PatientIds : '',
        adjustmentsGroupCodes: this.state.AdjustmentsGroupCodes ? this.state.AdjustmentsGroupCodes : '',
        payerName: this.state.payerName ? this.state.payerName : '',
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date().setDate(new Date().getDate() - 7),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
        claimStatusId: 1,
        masterClaimStatusCodes: this.state.MasterClaimStatusCodes ? this.state.MasterClaimStatusCodes : '',
        serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',
        tagIds: this.state.masterTags,
        isExcludeTag: this.state.isExcludeTag,
        fromPaidDate: this.state.FromPaidDate ? moment(this.state.FromPaidDate).format('YYYY-MM-DD') : null,
        toPaidDate: this.state.ToPaidDate ? moment(this.state.ToPaidDate).format('YYYY-MM-DD') : null,
        renderingProviderIds: this.state.RenderingProviderIds ? this.state.RenderingProviderIds : '',
        locationId: this.state.locationId ? this.state.locationId : 0,
        serviceLocationTypeIds: this.state.ServiceLocationTypeIds ? this.state.ServiceLocationTypeIds : '',
        //claimPaymentStatusIds: this.state.ClaimPaymentStatusIds ? this.state.ClaimPaymentStatusIds : '',
        claimPaymentStatusIds: IsNoPaymentStatus ? '0' : this.state.ClaimPaymentStatusIds ? this.state.ClaimPaymentStatusIds : null,
        authorizationNumberIds: this.state.AuthorizationNumberIds ? this.state.AuthorizationNumberIds.trim() : null,
        isActiveClientsOnly : this.props.isChecked,
        ChangedAfterBilling : this.state.isChangedAfterBilling,
      },
      pageNumber: page_number ? page_number : 1,
      pageSize: 50,
    };
    // console.log('searchObj........',searchObj)
    this.props.getProcessedClaims(searchObj);

  }


  componentWillMount() {

    let searchObj = {
      // locationIds: this.props.currentLocationId || '',
      locationIds: '0',
      isActiveCheckRequired: 'NO',
      isActiveClientsOnly : this.props.isChecked,
    };
    this.props.getPatient(searchObj);
     
    
    if(this.props.isCalledFromERA){
      this.setState({ClaimId: this.props.claimIdFromERA, IsSearchForSingleClaim: true}, ()=>{
        this.props.dispatch(change('ProcessedClaimForm',"claimId",this.props.claimIdFromERA));          
        this.loadData();
      });
    }


    if(this.props.claimId)
    {
        this.setState({ClaimId: this.props.claimId, IsSearchForSingleClaim: true}, ()=>{
          this.props.dispatch(reset('ProcessedClaimForm',"claimId", this.props.claimId));          
          this.loadData();
        });
    }
    else
    {
      this.loadData();
    }
    
    let masterData = { 'masterdata': 'masterInsuranceCompany,MASTERADJUSTMENTGROUPCODE,MASTERCLAIMSTATUSCODE,MASTERSERVICECODE,MASTERTAGSFORALL,MASTERRENDERINGPROVIDERINCLUDINGINACTIVE,MASTERLOCATION,MASTERPATIENTLOCATION,CLAIMPAYMENTSTATUS' };
    this.props.getClaimMasterData(masterData);
  }

  componentWillReceiveProps(nextProps) {  
    if (nextProps.edi837ForSecondary && nextProps.edi837ForSecondary !== this.props.edi837ForSecondary) {
      this.setState({ selectedEDIClaimIds: [], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber: []});
      this.ResetAllClaims();
      this.loadData();
    }

    if (nextProps.resubmitBatchClaim && nextProps.resubmitBatchClaim !== this.props.resubmitBatchClaim) {
      this.setState({ selectedEDIClaimIds: [], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber: []});
      this.ResetAllClaims();
      this.loadData();
    }
    if (nextProps.readyToBillClaimData && nextProps.readyToBillClaimData !== this.props.readyToBillClaimData) {           
      this.setState({ selectedEDIClaimIds: [], selectedNonEDIClaimIds: [], selectedEDIAndNonEDIClaimIds: [], selectedEDIClaimsPayerControlNumber: [] });
      this.ResetAllClaims();
      this.loadData();
    }

    if (nextProps.batchClaimRenderingProvider && nextProps.batchClaimRenderingProvider !== this.props.batchClaimRenderingProvider) {
      this.setState({
        selectedBatchClaimArray: [],
        selectedEDIClaimIds: [],
        selectedEDIClaimsPayerControlNumber: [],
        selectedNonEDIClaimIds: [],
        selectedEDIAndNonEDIClaimIds: []
      }, () => {
        this.ResetAllClaims();
        this.loadData();
      });
    }
  }
  
  componentWillUnmount(){
     this.props.getIscalledFromERAMouleFlag({flag:false,batchId:0})
  }

  handleOpenInternalNotes = (event, obj) => {
    // console.log('event, claimId.........', obj)
    this.setState({ openInternalNotesModal: true, ClaimId: obj.claimId });    
  };
    
  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;

      this.loadData();
    }
  }
  handleNewRequestMultiSelect(input, selectedValues) {    
    input.onChange(selectedValues);
    if (input.name === 'PatientIds') {
      this.setState({
        PatientIds: selectedValues,
      });
    } else if (input.name === 'AdjustmentsGroupCodes') {      
      this.setState({
        AdjustmentsGroupCodes: selectedValues,
      });
    } else if (input.name === 'MasterClaimStatusCodes') {      
      this.setState({
        MasterClaimStatusCodes: selectedValues,
      });
    }
    else if(input.name === 'MasterServiceCode')
    {      
      this.setState({
        ServiceCodes: selectedValues,
      });
    }
    else if(input.name === 'RenderingProviderIds')
    {
      this.setState({
        RenderingProviderIds: selectedValues,
      });
    }
    else if(input.name === 'ServiceLocationTypeIds')
    {      
      this.setState({
        ServiceLocationTypeIds: selectedValues,
      });
    }
    else if(input.name === 'ClaimPaymentStatus')
    {      
      this.setState({
        ClaimPaymentStatusIds: selectedValues,
      });
    }
  }

  handleChangePatientInsurance = (input, selected) => {
    input.onChange(selected.value);
    this.setState({ payerName: selected.label })
  }

  handleSyncERA = () => {
    this.props.ParseEDI835FromClearingHouseFromPage();
  }

  handleSyncERAFromMasterAccount = () => {
    this.props.ParseEDI835FromClearingHouseFromMasterAccount();
  }

  handleSearchProcessedClaim(event) {
    // event.preventDefault();
    // console.log('event............',event);
    this.setState({
      ClaimId: event.claimId ? event.claimId : null,
      IsSearchForSingleClaim: event.claimId ? true : false,
      PatientIds: this.state.PatientIds ? this.state.PatientIds : '',
      AdjustmentsGroupCodes: this.state.AdjustmentsGroupCodes ? this.state.AdjustmentsGroupCodes : '',
      PayerName: event.InsuranceCompany ? event.InsuranceCompany : '',
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: event.ToDate ? showFormatedDate(event.ToDate) : new Date(),
      MasterClaimStatusCodes: this.state.MasterClaimStatusCodes ? this.state.MasterClaimStatusCodes : '',
      serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',
      fromPaidDate: this.state.FromPaidDate ? moment(this.state.FromPaidDate).format('YYYY-MM-DD') : null,
      toPaidDate: this.state.ToPaidDate ? moment(this.state.ToPaidDate).format('YYYY-MM-DD') : null,
      // PayerName: event.InsuranceCompany ? event.InsuranceCompany : '',
      AuthorizationNumberIds: event.AuthorizationNumberIds ? event.AuthorizationNumberIds : null,
    }, () => {
      this.loadData();
    });
    // console.log('event............',event);
  }

  CheckClaim(e, index, claimId, secondaryPayerClaimControlNumber, payerClaimControlNumber) {
    let selectedEDIClaimIds = this.state.selectedEDIClaimIds;
    let selectedEDIClaimsPayerControlNumber = this.state.selectedEDIClaimsPayerControlNumber;
    let selectedEDIClaimsSecondaryPayerControlNumber = this.state.selectedEDIClaimsSecondaryPayerControlNumber;
    let isClaimChecked = e.target.checked;
    if (isClaimChecked) {
      selectedEDIClaimIds.push(claimId);      
      selectedEDIClaimsPayerControlNumber.push(payerClaimControlNumber);
      selectedEDIClaimsSecondaryPayerControlNumber.push(secondaryPayerClaimControlNumber);
    } else {
      index = selectedEDIClaimIds.findIndex((value) => value === claimId);
      if (index >= 0) {
        selectedEDIClaimIds.splice(index, 1);
      }

      index = selectedEDIClaimsSecondaryPayerControlNumber.findIndex((value) => value === secondaryPayerClaimControlNumber);
      if (index >= 0) {
        selectedEDIClaimsSecondaryPayerControlNumber.splice(index, 1);
      }

      index = selectedEDIClaimsPayerControlNumber.findIndex((value) => value === payerClaimControlNumber);
      if (index >= 0) {
        selectedEDIClaimsPayerControlNumber.splice(index, 1);
      }

    }

    this.setState({ selectedEDIClaimIds, selectedEDIClaimsPayerControlNumber, selectedEDIClaimsSecondaryPayerControlNumber });
  }
  // onDateChange(input, value) {
  //   input.onChange(moment(value).format());
  //   this.setState({ [input.name]: value });
  // }

  // handleExpandRow = (claimId) => {
  //   this.setState({ ClaimId: claimId });
  //   let display = this.refs['expandedClass' + claimId].style.display;

  //   // if(document.getElementsByClassName('nohover').length)
  //   // {
  //   //     let elements = document.getElementsByClassName('nohover');
  //   //     for(let i=0;i<elements.length;i++){
  //   //      elements[i].style.display = 'none';
  //   //     }

  //   //     let elements1 = document.getElementsByClassName('classExpand');
  //   //     for(let i=0;i<elements1.length;i++){
  //   //      elements1[i].className = 'classExpand fa fa-ellipsis-h';
  //   //     }
  //   // }

  //   if (display === 'none') {
  //     this.refs['expandedClass' + claimId].style.display = 'table-row';
  //     this.refs['expClass' + claimId].className = 'classExpand fa fa-minus';
  //   } else {
  //     this.refs['expandedClass' + claimId].style.display = 'none';
  //     this.refs['expClass' + claimId].className = 'classExpand fa fa-ellipsis-h';
  //   }
  // }

  updateAlternateServiceCode = (e, claimId, claimServiceLineId) => {
    var editableText = (e.target.value || '').trim();
    let postData = {};
    if (editableText) {
      this.setState({
        editClaimServiceLineId: 0,
      });
      postData = {
        claimId: claimId,
        id: claimServiceLineId,
        alternateServiceCode: editableText,
      };
    }
    else{
      postData = {
        claimId: claimId,
        id: claimServiceLineId,
        alternateServiceCode: null,
      };
    }
    // console.log('postData values to send...', JSON.stringify(postData));
    let alternateServiceCode = `ClaimServiceLine[${claimServiceLineId}].alternateServiceCode`;
    this.props.dispatch(change('ProcessedClaimForm', alternateServiceCode, editableText));

    this.props.updateClaimServiceLineDetails(postData);
    // this.loadData();
  }

  handleEditAlternateServiceCode(e, claimServiceLineId, editableText) {
    this.setState({
      editClaimServiceLineId: claimServiceLineId,
      ClickedOn: 'servicecode'
    },()=>{
      let alternateServiceCode = `ClaimServiceLine[${claimServiceLineId}].alternateServiceCode`;
      this.props.dispatch(change('ProcessedClaimForm', alternateServiceCode, editableText));
    });
  }

  updateAlternateModifier = (e, claimId, claimServiceLineId, label) => {
    var editableText = (e.target.value || '').trim();
    let postData = {};

    if(label === 'modifier1') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier1: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier1: null,
        };
      }
    }
    else if(label === 'modifier2') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier2: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier2: null,
        };
      }
    }
    else if(label === 'modifier3') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier3: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier3: null,
        };
      }
    }
    else if(label === 'modifier4') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier4: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier4: null,
        };
      }
    }
    // console.log('postData values to send...', JSON.stringify(postData));
    let alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
      
    if(label === 'modifier1')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
    else if(label === 'modifier2')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier2`;
    else if(label === 'modifier3')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier3`;
    else if(label === 'modifier4')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier4`;   

    this.props.dispatch(change('ProcessedClaimForm', alternateModifier, editableText));

    this.props.updateClaimServiceLineModifier(postData, label);
    // this.loadData();
  }

  handleEditAlternateModifier(e, claimServiceLineId, editableText, label) {    
    this.setState({
      editClaimServiceLineId: claimServiceLineId,
      ClickedOn: label
    },()=>{      
      let alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
      
      if(label === 'modifier1')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
      else if(label === 'modifier2')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier2`;
      else if(label === 'modifier3')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier3`;
      else if(label === 'modifier4')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier4`;   

        this.props.dispatch(change('ProcessedClaimForm', alternateModifier, editableText));
    });
  }


  handleOnSubmit = (event, obj) => {
    // console.log('obj.............',obj);
    // console.log('obj.............', Obj);
    return this.setState({ openSubmitClaimModal: true, ClaimId: obj.claimId, PatientId: obj.patientId, organizationID: this.props.loginUserInfo.organizationID });
    // this.setState({ openSubmitClaimModal: true, ClaimId: obj.claimId, PatientId: 365 });
  }
  // handleAlertBatchEDIGenerationClick = (event) => {
  //   this.props.SubmitBatchEDIClaimForSecondary(this.state.selectedEDIClaimIds.toString());
  //   Alert.closeAll();
  // }

  handleBatchEDIGenerationForSecondary = (event) => {
    this.setState({ openBatchSubmitClaimToSecondaryModal: true });
  //   Alert.warning('Are you sure you want to submit selected claims for EDI generation?', {
  //     position: 'bottom-right',
  //     effect: 'slide',
  //     timeout: 10000,
  //     customFields: {
  //       displayComponent: true,
  //       handleButtonClick: this.handleAlertBatchEDIGenerationClick,
  //       // id: obj.id,
  //     },
  //   });
  }

  handleBatchEDIGeneration = (event) => {

    this.setState({ openBatchResubmitClaimModal: true });
    // Alert.warning('Are you sure you want to re-submit selected claims for EDI generation?', {
    //   position: 'bottom-right',
    //   effect: 'slide',
    //   timeout: 10000,
    //   customFields: {
    //     displayComponent: true,
    //     handleButtonClick: this.handleAlertBatchEDIGenerationClick,
    //     //id: obj.id,
    //   },
    // });
  }
  handleChangeBatchRenderingProvider = (event) => {
    this.setState({ openBatchRenderingProviderModal: true });
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }
  handleClose = () => {
    this.setState({ openBatchGenerateForm1500Modal: false, openBatchSubmitClaimToSecondaryModal: false,openDownloadBatchClaimToSecondaryModal: false, openBatchResubmitClaimModal : false, openSubmitClaimModal: false, openInternalNotesModal: false, isAddNoteModalOpen: false,openBatchRenderingProviderModal: false,openDownloadBatchResubmitClaimModal: false,openBatchUpdateRateModal: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] }, () => this.handleReset());
  };

  closeDialog = () => {
    this.setState({ openBatchGenerateForm1500Modal: false, openBatchSubmitClaimToSecondaryModal: false, openDownloadBatchClaimToSecondaryModal: false, openBatchResubmitClaimModal : false, openSubmitClaimModal: false, openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] },()=>this.props.dispatch(reset('ProcessedClaimForm', 'chk', null)));
  };

  ResetAllClaims() {
    this.props.dispatch(change('ProcessedClaimForm', 'chk', false));    
    this.props.processedClaim.data.ProcessedClaims.map((Obj, index) => {
      let claimIdCheck = `Check${Obj.claimId}`;      
      this.props.dispatch(change('ProcessedClaimForm', claimIdCheck, false));
    });
  }

  handleDownloadBatchSecondaryEDIClick = (event) => {
    this.setState({ openDownloadBatchClaimToSecondaryModal: true });    
  }

  handleCloseWithoutReset = () => {    
    this.ResetAllClaims();
    this.setState({ openBatchGenerateForm1500Modal: false, openBatchSubmitClaimToSecondaryModal: false,openDownloadBatchClaimToSecondaryModal: false, openBatchResubmitClaimModal : false, openSubmitClaimModal: false, openInternalNotesModal: false, isAddNoteModalOpen: false,openBatchRenderingProviderModal: false,openDownloadBatchResubmitClaimModal: false,openBatchUpdateRateModal: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] });
  }

  handleClaimIDCheck = (input) => {
    // console.log('input.target.name......', input.target.value);
    // console.log('input.target.checked......', input.target.checked);
    let inputName = input.target.value;
    let inputvalue = inputName.replace('Check', '');
    // console.log('inputvalue......', inputvalue);
    let value = parseInt(inputvalue, 10);
    if (input.target.checked) {
      let claimArray = this.state.claimIdArray,
        id = Number.isInteger(value) ? value : null;
      claimArray.push(id);
      this.setState({
        claimIdArray: claimArray || null,
      });
      // console.log('this.state.claimIdArray................', this.state.claimIdArray);
    } else {
      let claimArray = this.state.claimIdArray,
        index = claimArray.indexOf(value);
      if (index >= 0) {
        claimArray = claimArray.splice(index, 1);
        this.setState({
          claimIdArray: claimArray || null,
        });
        // console.log('this.state.claimIdArray................', this.state.claimIdArray);

      }
    }
  }
  handleReset = () => {
    this.props.dispatch(reset('ProcessedClaimForm'));
    resetFiltersAndSorting(this.filter, 'claimId', true);
    this.setState({
      openInternalNotesModal: false,
      openDownloadBatchResubmitClaimModal: false,
      ClaimId: null,
      PatientIds: null,
      AdjustmentsGroupCodes: null,
      masterClaimStatusCodes: null,
      PayerName: null,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      claimIdArray: [],
      masterTags: [],
      isExcludeTag: [],
      FromPaidDate: null,
      ToPaidDate: null,
      RenderingProviderIds: null,
      locationId: 0,
      ServiceLocationTypeIds: null,
      ClaimPaymentStatusIds: null,
      AuthorizationNumberIds: null,
    }, () => {
      this.loadData();
    });
  };
  handleExpandRow = (claimId) => {
    this.setState({ ClaimId: claimId });
    let display = this.refs['expandedClass' + claimId].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + claimId].style.display = 'table-row';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + claimId].style.display = 'none';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-ellipsis-h';
    }
  }
  checkAllClaimId(input, claimId) {
    // console.log('input.target.checked.........', e.target.checked);
    let selectedEDIClaimIds = [];
    let selectedEDIClaimsPayerControlNumber = [];
    let selectedEDIClaimsSecondaryPayerControlNumber = [];
    this.props.processedClaim.data.ProcessedClaims.map((Obj, index) => {
      let claimCheck = 'Check' + Obj.claimId;
      if (Obj && input.target.checked) {
        selectedEDIClaimIds.push(Obj.claimId);
        selectedEDIClaimsPayerControlNumber.push(Obj.payerClaimControlNumber);
        selectedEDIClaimsSecondaryPayerControlNumber.push(Obj.secondaryPayerClaimControlNumber);
        // console.log('actionCheck........', actionCheck);
        return this.props.dispatch(change('ProcessedClaimForm', claimCheck, true));
      } else {
        // console.log('actionUnCheck........', actionCheck);
        return this.props.dispatch(change('ProcessedClaimForm', claimCheck, false));
      }
    });
    this.setState({ selectedEDIClaimIds, selectedEDIClaimsPayerControlNumber, selectedEDIClaimsSecondaryPayerControlNumber });
  }


  handleExpandRowAdjustment = (claim835ServiceLineId) => {
    this.setState({ claim835ServiceLineId: claim835ServiceLineId });
    let display = this.refs['expandedClass' + claim835ServiceLineId].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + claim835ServiceLineId].style.display = 'table-row';
      this.refs['expInnerClass' + claim835ServiceLineId].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + claim835ServiceLineId].style.display = 'none';
      this.refs['expInnerClass' + claim835ServiceLineId].className = 'classExpand fa fa-ellipsis-h';
    }
  }
  renderInnerAdjustmentData(claim835ServiceLineId, payerName) {
    let processedClaimAdjustmentInnerData = this.props.processedClaim.data.ProcessedClaimServiceLineAdjustments || [],
      filteredProcessedClaimAdjustmentInnerData = processedClaimAdjustmentInnerData.filter((obj) => obj.claim835ServiceLineId === claim835ServiceLineId);
    return filteredProcessedClaimAdjustmentInnerData.map((data, index) => {
      return (
        <tr key={index}>
          <td></td>
          <td></td>
          <td>{payerName}</td>
          <td>{showNormalizedRate(data.amountAdjusted)}</td>
          <td>{data.adjustmentGroupCode}</td>
          <td>{data.adjustmentReasonCode}</td>
        </tr>
      );
    });
  }

  handleOpenHistory = (event, claimId) => {
    this.setState({
      openClaimHistoryModal: true,
      ClaimId: claimId
    });
  }

  handleCloseClaimHistoryModal = () => {
    this.setState({
      openClaimHistoryModal: false
    });
  }

  
  handleAddBulkNoteClick = () => {
    this.setState({
      isAddNoteModalOpen: true
    })
  }

  handleNewRequest = (input, selectedValues) => {
    if (input.name === 'tags') {      
        input.onChange(selectedValues);
        this.setState({
          masterTags: selectedValues,
        }, () => this.state.masterTags.length === 0 ? this.props.dispatch(reset('ProcessedClaimForm',"ExcludeTag", false)): '');
    }
    else if (input.name === 'locationId') {              
      this.setState({  locationId : selectedValues.value }, () => {input.onChange(selectedValues.value);});
    }    
  }

  
  isExcludeTagHandler = (e) => {
    this.setState({
      isExcludeTag: !this.state.isExcludeTag
    });
  }

  isChangedAfterBilling = (e) => {
    this.setState({isChangedAfterBilling : !this.state.isChangedAfterBilling})
  }

  isActiveClientHandler = async(e) =>{
    await this.props.handleToggle();
    this.loadData();
  }

  handleSubmitBatchPaperClaimsForNonEDIPayers = (event) => {
    this.setState({ openBatchGenerateForm1500Modal: true });
    // Alert.warning('Are you sure you want to mark as submit to selected claims for non EDI payers?', {
    //   position: 'bottom-right',
    //   effect: 'slide',
    //   timeout: 10000,
    //   customFields: {
    //     displayComponent: true,
    //     handleButtonClick: this.handleAlertSubmitBatchPaperClaimsForNonEDIPayers,
    //     // id: obj.id,
    //   },
    // });
  }

  handleCloseBatchEDIGeneration = () => {
    this.setState({ openBatchGenerateForm1500Modal: false, openBatchSubmitClaimToSecondaryModal: false,openDownloadBatchClaimToSecondaryModal: false, openBatchResubmitClaimModal : false, openSubmitClaimModal: false, openInternalNotesModal: false, isAddNoteModalOpen: false,openBatchRenderingProviderModal: false,openDownloadBatchResubmitClaimModal: false,openBatchUpdateRateModal: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] },()=>{
      this.ResetAllClaims();
    });    
  }

  handleDownloadClick = (docId, fileName) => {
    this.props.EDI835Download(docId, fileName);
  }
  handleBatchUpdateRate = (event) => {
    this.setState({ openBatchUpdateRateModal: true });
  }  

  handleDownloadBatchEDIClick = (event) => {
    this.setState({ openDownloadBatchResubmitClaimModal: true });    
  }
  handleAlertDownloadBatchEDIClick = (event) => {
    this.props.downloadBatchEDI837(this.state.selectedEDIAndNonEDIClaimIds.toString());
    Alert.closeAll();
  }
  handleDownloadBatchEDI_Click = (event) => {
    Alert.warning('Are you sure you want to download selected EDI claims?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertDownloadBatchEDIClick,
        //id: obj.id,
      },
    });
  }

  renderInnerData(claim835ClaimId, payerName, claimId) {
    const tableClass3 = classNames({
      'table': true,
      'childtable': true,
      'customtable': false,
    });
    // console.log('this.props.processedClaim.......', this.props.processedClaim);
    let processedClaimInnerData = this.props.processedClaim.data.ProcessedClaimServiceLines || [],
      filteredProcessedClaimInnerData = processedClaimInnerData.filter((obj) => obj.claim835ClaimId === claim835ClaimId);
    return filteredProcessedClaimInnerData.map((innerData, index) => {
      return (
        <tbody key={index}>
          <tr>
            <td width="5%"></td>
            <td width="5%"> <div className="table_custom-check">
              <button onClick={(e) => this.handleExpandRowAdjustment(innerData.claim835ServiceLineId+''+innerData.claimServicelineId)} type="button" className="morebtn">
                <i ref={'expInnerClass' + innerData.claim835ServiceLineId+''+innerData.claimServicelineId} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
              </button>
            </div></td>
            <td width="10%">{innerData.serviceCode}</td>
            <td width="8%">{innerData.serviceLineDOS ? showFormatedDate(innerData.serviceLineDOS) : ''}</td>
            <td width="7%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.alternateServiceCode) && (!innerData.alternateServiceCode || this.state.ClickedOn === 'servicecode')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].alternateServiceCode`}
                type="text"
                maxLength="80"
                value={innerData.alternateServiceCode}
                hintText={'Service Code'}
                onBlur={(e) => this.updateAlternateServiceCode(e, claimId, innerData.claimServicelineId)}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateServiceCode(e, innerData.claimServicelineId, innerData.alternateServiceCode)}>
                  {innerData.alternateServiceCode}
                </span>)}
          </td>
          <td width="7%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier1) && (!innerData.modifier1 || this.state.ClickedOn === 'modifier1')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier1`}
                type="text"
                maxLength="80"
                value={innerData.modifier1}
                hintText={'Modifier 1'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier1')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier1, 'modifier1')}>
                  {innerData.modifier1}
                </span>)}
          </td>
          <td width="7%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier2) && (!innerData.modifier2 || this.state.ClickedOn === 'modifier2')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier2`}
                type="text"
                maxLength="80"
                value={innerData.modifier2}
                hintText={'Modifier 2'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier2')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier2, 'modifier2')}>
                  {innerData.modifier2}
                </span>)}
          </td>
          <td width="7%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier3) && (!innerData.modifier3 || this.state.ClickedOn === 'modifier3')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier3`}
                type="text"
                maxLength="80"
                value={innerData.modifier3}
                hintText={'Modifier 3'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier3')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier3, 'modifier3')}>
                  {innerData.modifier3}
                </span>)}
          </td>
          <td width="7%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier4) && (!innerData.modifier4 || this.state.ClickedOn === 'modifier4')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier4`}
                type="text"
                maxLength="80"
                value={innerData.modifier4}
                hintText={'Modifier 4'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier4')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier4, 'modifier4')}>
                  {innerData.modifier4}
                </span>)}
          </td>
          <td width="4%">{innerData.quantity || '-'}</td>
            <td width="5%">{showNormalizedRate(innerData.rate || 0)}</td>
            <td width="7%">{showNormalizedRate(innerData.totalAmount || 0)}</td>
            <td width="7%">{innerData.serviceFacilityCode}</td>            
            <td width="7%">{showNormalizedRate(innerData.amountCharged)}</td>
            <td width="7%">{showNormalizedRate(innerData.amountApproved)}</td>
            {/* <td width="15%">{innerData.unitCharged}</td>
            <td width="15%">{innerData.unitApproved}</td> */}
            
          </tr>
          <tr className="nohover" ref={'expandedClass' + innerData.claim835ServiceLineId+''+innerData.claimServicelineId} style={{ 'display': 'none' }}>
            <td></td>
            <td colSpan="13">
              <table className={tableClass3}>
                <thead>
                  <tr>
                    <th width="10%"></th>
                    <th width="5"></th>
                    <th width="25%"> Payer</th>
                    <th width="20%">Adj($)</th>
                    <th width="20%">Adj Group Code</th>
                    <th width="20%">Adj Reason Code</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderInnerAdjustmentData(innerData.claim835ServiceLineId, payerName)}
                </tbody>
              </table>
            </td>
          </tr>

        </tbody>
      );
    });
  };

  renderData() {
    const tableClass1 = classNames({
      'table': true,
      'middletable ': true,
      'customtable': true,
      'colorChange': true,
    });
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    return this.props.processedClaim.data.ProcessedClaims.map((Obj, index) => {
      // console.log('Obj.......',Obj );
      return (
        <tr key={index}>
          <td colSpan="14">
            <table className={tableClass1}>
              <tbody>
                <tr>
                  <td width="6%"> <div className="table_custom-check">
                    <Field
                      name={'Check' + Obj.claimId}                      
                      // onChange={this.handleClaimIDCheck}
                      disabled= {Obj.applied && Obj.applied === true ? false : false}
                      onChange={(e) => this.CheckClaim(e, index, Obj.claimId, Obj.secondaryPayerClaimControlNumber, Obj.payerClaimControlNumber)}
                      component={renderCheckBox}
                      style={stylescss.checkbox}
                    />
                    <button onClick={(e) => this.handleExpandRow(Obj.claimId)} type="button" className="morebtn">
                      <i ref={'expClass' + Obj.claimId} className="classExpand fa fa-minus" aria-hidden="true"></i>
                    </button>
                  </div></td>
                  <td width="9%">{'CL' + Obj.claimId}</td>
                  {/* <td width="8%">{showFormatedDate(Obj.dos)}</td> */}
                  <td width="9%">{Obj.patientName}</td>
                  <td width="6%">{showNormalizedRate(Obj.amountClaimed || 0)}</td>
                  <td width="6%" >{showNormalizedRate(Obj.patientResponsibilityAmount || 0)}</td>
                  <td width="6%">{showNormalizedRate(Obj.amountApproved || 0)}</td>
                  <td width="6%">{Obj.claimPaidDate !== '0001-01-01T00:00:00' ? showFormatedDate(Obj.claimPaidDate) : 'N/A'}</td>                  
                  <td width="10%">{Obj.authorizationNumber}</td>                                      
                  <td width="9%">{Obj.submittedAs}</td>                  
                  <th width="10%">{Obj.claimPaymentStatus}</th>
                  <td width="10%">{Obj.payerClaimControlNumber}</td>
                  <td width="10%">{Obj.processedAs}</td>                  
                  <td width="5%">
                    {/* <button onClick={(e) => this.handleOnSubmit(e, Obj)} type="button" title="Submit" className="tbactionbtn bluefont"><i className="fa fa-paper-plane" aria-hidden="true"></i></button> */}
                    <button onClick={(e) => this.handleOpenInternalNotes(e, Obj)} type="button" title="Claim Internal Notes" className="tbactionbtn bluefont"><i className="fa fa-sticky-note-o" aria-hidden="true"></i></button>
                    <button onClick={(e) => this.handleOpenHistory(e, Obj.claimId)} type="button" title="Claim History" className="tbactionbtn bluefont"><i className="fa fa-history" aria-hidden="true"></i></button>
                    {Obj.filename ?
                    <button onClick={(e) => this.handleDownloadClick(Obj.claim835BatchId, Obj.filename)} type="button" title="Download ERA" className="tbactionbtn bluefont"><i className="fa fa-download" aria-hidden="true"></i></button>
                    :null}
                  </td>
                </tr>
                <tr className="nohover" ref={'expandedClass' + Obj.claimId} style={{ 'display': 'table-row' }}>
                  <td colSpan="13">
                    <table className={tableClass2}>
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <th width="5%"></th>
                          <th width="10%">Service Code</th>
                          <th width="8%">DOS</th>            
                          <th width="7%">Alt. Code</th>
                          <th width="7%">Alt. Modifier1</th>
                          <th width="7%">Alt. Modifier2</th>
                          <th width="7%">Alt. Modifier3</th>
                          <th width="7%">Alt. Modifier4</th>                          
                          <th width="4%">Unit</th>
                          <th width="5%">Rate($)</th>
                          <th width="7%">Amount($)</th>
                          <th width="7%">Loc. Code</th>  
                          <th width="7%">Amt. Charged</th>
                          <th width="7%">Amt. Approved</th>
                          {/* <th width="15%">Unit Charged</th>
                          <th width="15%">Unit Approved</th> */}                       
                        </tr>
                      </thead>
                      {this.renderInnerData(Obj.claim835ClaimId, Obj.payerName, Obj.claimId)}
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'customtable': true,
    });
    // const tableClass1 = classNames({
    //   'table': true,
    //   'maintable': true,
    //   'customtable': true,
    // });
    return (
      <div>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchProcessedClaim)}>
              <div className="row mtm-20">
                <div className="col-sm-4">
                  <Field
                    autoFocus={true}
                    name="claimId"
                    floatingLabelText="Claim ID"
                    onChange={this.handleSearchChange}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="PatientIds"
                    label="Client Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.patientlist}
                    component={renderAutoCompleteMultipleSelection}/>
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="MasterServiceCode"
                    label="Service Code"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterServiceCode}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection = {true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="InsuranceCompany"
                    label="Insurance Company"
                    handleNewRequest={this.handleChangePatientInsurance}
                    options={this.props.masterInsurances}
                    component={renderAutoCompleteSingleSelect} />
                  {/* <Field name="InsuranceCompany"
                    floatingLabelText="Insurance Company"
                    maxLength="50"
                    onChange={this.handleSearchChange}
                    component={renderTextField} /> */}
                </div>
              </div>
              <div className="row">
              <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="tags"
                    label="Tags"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterTagsForAll}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="AdjustmentsGroupCodes"
                    label="Adjustments Group Codes"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.AdjustmentsGroupCode}
                    component={renderAutoCompleteMultipleSelection}/>
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="MasterClaimStatusCodes"
                    label="Claim Status"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.MasterClaimStatusCodes}
                    component={renderAutoCompleteMultipleSelection}/>
                </div>  
              </div>   
              <div className="row"> 
              {this.state.masterTags.length > 0 ?
                <div className="col-sm-3 insfield mt-35">
                 <Field
                    name="ExcludeTag"
                    label="Exclude Tag"
                    component={renderCheckBox}
                    onChange={(e) => this.isExcludeTagHandler(e)}
                    style={stylescss.checkbox}
                  />
                </div>              
                :null}
                <div className="col-sm-3">
                  <Field name="FromPaidDate"
                    placeholder="From Paid Date"
                    locale="en-US"
                    selected={this.state.FromPaidDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-3">
                  <Field name="ToPaidDate"
                    placeholder="To Paid Date"
                    locale="en-US"
                    selected={this.state.ToPaidDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-3 insfield mt-35">
                  <Field
                    name="DisplayActiveClient"
                    label="Display active clients only"
                    component={renderCheckBox}
                    onChange={this.isActiveClientHandler}
                    style={stylescss.checkbox}
                    checked ={this.props.isChecked}
                  />
                </div>
              </div>
              <div className="row"> 
                <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="RenderingProviderIds"
                      label="Rendering Provider"
                      handleNewRequest={this.handleNewRequestMultiSelect}
                      options={this.props.masterRenderingProviderIncludingInactive}
                      component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="locationId"
                    label="Location (Office Location of Session)"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterLocation}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="ServiceLocationTypeIds"
                    label="Service Location Type"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterPatientLocation}
                    component={renderAutoCompleteMultipleSelection} />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="ClaimPaymentStatus"
                      label="Payment Ledger Status"
                      handleNewRequest={this.handleNewRequestMultiSelect}
                      options={this.props.masterClaimPaymentStatus}
                      component={renderAutoCompleteMultipleSelection}
                    />
                  </div>
                  <div className="col-sm-4">
                    <Field
                      name="AuthorizationNumberIds"
                      floatingLabelText="Authorization Number"
                      onChange={this.handleSearchChange}
                      component={renderTextField} />
                  </div>
                  <div className="col-sm-4 mt-35">
                    <Field
                      name="changedAfterBilling"
                      label="Changed after billing"
                      component={renderCheckBox}
                      onChange={this.isChangedAfterBilling}
                      style={stylescss.checkbox}
                    />
                  </div>
              </div>
              <div className="row">         
                <div className="col-10 col-sm-10 col-md-10 reset-btn claims_btn">                
                  {this.props.agencyName.toUpperCase() !== ART && this.props.agencyName.toUpperCase() !== BALLSBRIDGEBCS ?
                    <RaisedButton className="grey_btn" onTouchTap={(e) => this.handleSyncERA(e)} >Clearing House Sync</RaisedButton>
                  :null}

                  {(this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === STEPUPOUTPATIENT) && this.props.agencyName.toUpperCase() !== EBS ?
                    <RaisedButton className="grey_btn ml_15" onTouchTap={(e) => this.handleSyncERAFromMasterAccount(e)} >Sync ERA From Master Account</RaisedButton>
                  :null} 
                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? 'grey_btn ml_15' : 'grey_btn ml_15 reset-disable'} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleBatchEDIGeneration(e)} >Batch EDI Generation For Primary Payer</RaisedButton>                                  
                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? 'grey_btn ml_15' : 'grey_btn ml_15 reset-disable'} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleBatchEDIGenerationForSecondary(e)} >Batch EDI Generation For Secondary Payer</RaisedButton>
                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleSubmitBatchPaperClaimsForNonEDIPayers(e)} >Batch Form 1500 Generation For Secondary Payer</RaisedButton>
                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleAddBulkNoteClick(e)} >Add Bulk Note</RaisedButton>

                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? 'grey_btn ml_15' : 'grey_btn ml_15 reset-disable'} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleBatchEDIGeneration(e)} >Batch EDI Generation</RaisedButton>

                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleChangeBatchRenderingProvider(e)} >Batch Change Rendering Provider</RaisedButton>

                   <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} 
                   disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                    onTouchTap={(e) => this.handleDownloadBatchEDI_Click(e)} >Download Batch EDI</RaisedButton>

                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleDownloadBatchEDIClick(e)} >Download Batch EDI For Resubmission</RaisedButton>
                  {/* <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} 
                  // disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleBatchUpdateRate(e)} >Batch Update Rates</RaisedButton>   */}
                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? 'grey_btn ml_15' : 'grey_btn ml_15 reset-disable'} 
                  disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true}
                   onTouchTap={(e) => this.handleDownloadBatchSecondaryEDIClick(e)} >Download Batch EDI For Secondary Submission</RaisedButton>
                                       <RaisedButton className={this.state.selectedEDIAndNonEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} 
                                       disabled={this.state.selectedEDIAndNonEDIClaimIds.length > 0 ? false : true}
                                        onTouchTap={(e) => this.handleBatchUpdateRate(e)} >Batch Update Rates</RaisedButton>

                  <RaisedButton className="grey_btn ml_15" onClick={(e) => this.uploadDocumenthandler(e)} >Upload ERA</RaisedButton>
                </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt reset-btn claims_filter">
                  <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                  <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                </div>
              </div>
            </form>
            {this.state.openSubmitClaimModal && this.state.ClaimId ? <SubmitClaimForSecondaryPayerModal ClaimId={this.state.ClaimId} PatientId={this.state.PatientId} OrganizationId={this.state.organizationID} closeDialog={this.handleClose} /> : null}

            {this.state.openInternalNotesModal ? <ClaimInternalNotesModal claimId={this.state.ClaimId} closeDialog={this.handleCloseWithoutReset} /> : null}

            {this.state.openBatchGenerateForm1500Modal && <BatchGenerateForm1500SecondaryFromProcessedClaimsModal selectedEDIClaimIds={this.state.selectedEDIClaimIds} closeDialog={this.handleCloseBatchEDIGeneration} />}

            {this.state.isAddNoteModalOpen ? <AddNoteModal ClaimId={this.state.ClaimId} PatientId={this.state.PatientId} OrganizationId={this.state.organizationID} closeDialog={this.handleCloseWithoutReset} claimIds={this.state.selectedEDIClaimIds}/> : null}

            {this.state.openBatchRenderingProviderModal && <BatchRenderingProviderModal selectedEDIAndNonEDIClaimIds={this.state.selectedEDIAndNonEDIClaimIds} renderingProviderIncludingInactive={this.props.masterRenderingProviderIncludingInactive} closeDialog={this.handleCloseBatchEDIGeneration} />}
 

            {this.state.openClaimHistoryModal ? <CliamHistoryModal claimHistoryId={this.state.ClaimId}  PatientId={this.state.PatientId}  closeDialog={() => this.handleCloseClaimHistoryModal()}/> : null}

            {this.state.openBatchSubmitClaimToSecondaryModal && <BatchSubmitClaimToSecondaryModal isDownloadEDI = {false} selectedBatchClaimArray={this.state.selectedEDIClaimIds} selectedEDIClaimsPayerControlNumber={this.state.selectedEDIClaimsSecondaryPayerControlNumber} closeDialog={this.handleClose} />}
            
            {this.state.openDownloadBatchClaimToSecondaryModal && <BatchSubmitClaimToSecondaryModal isDownloadEDI = {true} selectedBatchClaimArray={this.state.selectedEDIClaimIds} selectedEDIClaimsPayerControlNumber={this.state.selectedEDIClaimsSecondaryPayerControlNumber} closeDialog={this.handleClose} />}
            
            {this.state.openDownloadBatchResubmitClaimModal && <BatchResubmitClaimModal isDownloadEDI = {false} selectedBatchClaimArray={this.state.selectedEDIClaimIds} selectedEDIClaimsPayerControlNumber={this.state.selectedEDIClaimsPayerControlNumber} closeDialog={this.handleClose} />}
            {this.state.openBatchUpdateRateModal && <BatchUpdateRateModal selectedEDIAndNonEDIClaimIds={this.state.selectedEDIAndNonEDIClaimIds} closeDialog={this.handleCloseBatchEDIGeneration} />}

            {this.state.isUpload_ERA ? <Upload_ERA_Modal open={this.state.isUpload_ERA} closeDialog={this.closeUploadDocument} /> : null}
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-20">
                  {this.props.processedClaim.data && this.props.processedClaim.data.ProcessedClaims && this.props.processedClaim.data.ProcessedClaims.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="6%"><div className="table_custom-check">
                            <Field
                              name= 'chk'
                              // onChange={this.handleClaimIDCheck}
                              component={renderCheckBox}
                              onChange={(input) => this.checkAllClaimId(input, this.props.processedClaim.data.ProcessedClaims.claimId)}
                              style={stylescss.checkbox}
                            />
                          </div></th>
                          <th width="9%"><SortingCustom setSortColumn={this.setSortColumn} columnName='claimId' displayName='Claim ID' /></th>
                          {/* <th width="8%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dos' displayName='DOS' /></th>                          */}
                          <th width="9%"><SortingCustom setSortColumn={this.setSortColumn} columnName='patientName' displayName='Client' /></th>
                          <th width="6%"><SortingCustom setSortColumn={this.setSortColumn} columnName='amountClaimed' displayName='Claim Amt.' /></th>
                          <th width="6%"><SortingCustom setSortColumn={this.setSortColumn} columnName='patientResponsibilityAmount' displayName='Client Res.' /></th>
                          <th width="6%"><SortingCustom setSortColumn={this.setSortColumn} columnName='amountApproved' displayName='Ins. Paid' /></th>
                          <th width="6%"><SortingCustom setSortColumn={this.setSortColumn} columnName='claimPaidDate' displayName='Paid Date' /></th> 
                          <th width="10%">Authorization Number</th>
                          <th width="9%">Submitted To</th>
                          <th width="10%">Payment Ledger Status</th>
                          <th width="10%">Payer Ctrl. #</th>
                          <th width="10%">Status</th>
                          <th width="5%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="6%"><span>&nbsp;</span></th>
                          <th width="9%"><span>Claim ID</span></th>
                          {/* <th width="8%"><span>DOS</span></th> */}
                          <th width="9%"><span>Client</span></th>
                          <th width="6%"><span>Claim Amt.</span></th>
                          <th width="6%"><span>Client Res.</span></th>
                          <th width="6%">Ins. Paid</th>
                          <th width="6%"><span>Paid Date</span></th>
                          <th width="10%">Authorization Number</th>
                          <th width="9">Submitted To</th>
                          <th width="10%">Payment Ledger Status</th>
                          <th width="10%">Payer Ctrl. #</th>
                          <th width="10">Status</th>
                          <th width="5%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="14">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }                 
                  {this.props.processedClaim.data && this.props.processedClaim.meta && this.props.processedClaim.meta['totalPages'] && this.props.processedClaim.meta['totalPages'] > 1 ?
                  <PaginatorCustom data={this.props.processedClaim.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                  : null}
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    );
  }
};
ProcessedClaim = reduxForm({
  form: 'ProcessedClaimForm',
})(ProcessedClaim);

function mapStateToProps(state) {
//  console.log('state.billing.master_data............',state.billing)
  let patients = [];
  if (state.billing.patientList && state.billing.patientList.data) {
    patients = state.billing.patientList.data.patients;
  }
  let masterInsurances = [], masterAdjustmentTypes = [], masterClaimStatusCode = [], masterServiceCode = [];
  let masterTagsForAll = [], masterRenderingProviderIncludingInactive = [];
  let masterLocation = [],  masterPatientLocation = [];
  if (state.billing.claimMasterData) {
    masterInsurances = state.billing.claimMasterData.insuranceCompanies || [];
    masterAdjustmentTypes = state.billing.claimMasterData.adjustmentGroupCodeModel || [];
    masterClaimStatusCode = state.billing.claimMasterData.masterClaimStatusCode || [];
    masterServiceCode = state.billing.claimMasterData.masterServiceCode || [];
    masterTagsForAll = state.billing.claimMasterData.masterTagsforAll || [];
    masterRenderingProviderIncludingInactive = state.billing.claimMasterData.masterRenderingProviderIncludingInactive || [];
    masterLocation = state.billing.claimMasterData.masterLocation || [];
    masterPatientLocation = state.billing.claimMasterData.masterPatientLocation || [];
  }
  return {
    masterInsurances: masterInsurances,
    masterTagsForAll: masterTagsForAll,        
    masterServiceCode: masterServiceCode,
    masterRenderingProviderIncludingInactive: masterRenderingProviderIncludingInactive,
    processedClaim: state.billing.processedClaim,
    loginUserInfo: state.login.loginUserInfo,
    patientlist: patients,
    AdjustmentsGroupCode: masterAdjustmentTypes,
    MasterClaimStatusCodes: masterClaimStatusCode,
    edi837ForSecondary: state.billing.edi837ForSecondary,
    masterLocation: masterLocation,
    masterPatientLocation: masterPatientLocation,
    masterClaimPaymentStatus: (state.billing.claimMasterData && state.billing.claimMasterData.claimPaymentStatus) || [],
    resubmitBatchClaim: state.billing.resubmitBatchClaim,
    ParseEDI835Data: state.billing.ParseEDI835Data,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, { getIscalledFromERAMouleFlag,getClaimMasterData, getProcessedClaims, SubmitBatchEDIClaimForSecondary, getPatient, updateClaimServiceLineDetails, updateClaimServiceLineModifier, EDI835Download, ParseEDI835FromClearingHouseFromPage, ParseEDI835FromClearingHouseFromMasterAccount, downloadBatchEDI837 })(ProcessedClaim);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/ProccessedClaim.js